import ProjectSchedules from "./ProjectSchedules";
import GeneralInformation from "./GeneralInformation";
import Miscellaneous from "./Miscellaneous";
import ProjectFinancing from "./ProjectFinancing";
import Submit from "./Submit";
import { PROPOSAL_STATUS, programTypes} from "../Constants";

const modules = [
  {
    module: GeneralInformation,
    path: "/generalinformation",
    headerText: "General Information",
    programs: [],
    statuses: [],
  },
  {
    module: ProjectFinancing,
    path: "/projectfinancing",
    headerText: "Budget",
    programs: [],
    statuses: [],
  },
  {
    module: ProjectSchedules,
    path: "/projectschedules",
    headerText: "Project Schedules",
    programs: [programTypes.regularProgram, programTypes.CollaborativeTrack],
    statuses: [PROPOSAL_STATUS],
  },
  {
    module: Miscellaneous,
    path: "/miscellaneous",
    headerText: "Additional Information",
    programs: [programTypes.CollaborativeTrack,programTypes.SoloTrack],
    statuses: [PROPOSAL_STATUS]
  },
  {
    module: Submit,
    path: "/submit",
    headerText: "Submit",
    programs: [],
    statuses: [],
  },
];

export default modules;
